/**
 * A wrapper around the native fetch API that automatically adds the
 * Authorization header and handles 401 Unauthorized errors by logging out.
 *
 * @param {string} url - The URL to fetch.
 * @param {object} options - The options for the fetch request.
 * @param {string} token - The authentication token.
 * @param {function} logout - The logout function from AuthContext.
 * @returns {Promise<Response>} - The fetch response.
 */
export const authenticatedFetch = async (url, options, token, logout) => {
  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    logout();
    throw new Error('Session expired. Please log in again.');
  }

  return response;
};
